import { FunctionComponent, memo, useMemo } from 'react';
import { Event } from '../../../../services';
import { EventItemContent, EventItemUnavailable, useIsEventUnavailable } from '../../../../shared';

import classes from './EventDetail.module.scss';

interface EventProps {
  data: { event: Event | null };
}

export const EventDetail: FunctionComponent<EventProps> = memo(({ data: { event } }) => {
  const isEventUnavailable = useIsEventUnavailable();

  const content = useMemo(() => {
    if (isEventUnavailable(event)) {
      return <EventItemUnavailable />;
    }

    if (!event) {
      return null;
    }

    return (
      <div className={classes['event-content']}>
        <EventItemContent event={event} showDescription showViewLink />
      </div>
    );
  }, [event, isEventUnavailable]);

  return <>{content}</>;
});
